import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function UserAvatarIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.2 13.89c.362.11.85.11 1.68.11h6.24c.83 0 1.318 0 1.68-.11m-9.6 0a1.3 1.3 0 0 1-.217-.086 1.8 1.8 0 0 1-.787-.787C2 12.632 2 12.128 2 11.12V4.88c0-1.008 0-1.512.196-1.897a1.8 1.8 0 0 1 .787-.787C3.368 2 3.872 2 4.88 2h6.24c1.008 0 1.512 0 1.897.196a1.8 1.8 0 0 1 .787.787C14 3.368 14 3.872 14 4.88v6.24c0 1.008 0 1.512-.196 1.897a1.8 1.8 0 0 1-.787.787q-.102.051-.217.086m-9.6 0c0-.485.003-.742.046-.958a2.4 2.4 0 0 1 1.886-1.886C5.364 11 5.642 11 6.2 11h3.6c.558 0 .836 0 1.068.046a2.4 2.4 0 0 1 1.886 1.886c.043.216.046.473.046.958M10.4 6.5a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0" /></svg>
  );
}

export default UserAvatarIcon;
